export const ERROR_HANDLE_ERROR = 'handleError';
export const ERROR_CLEAR_ERROR = 'clearError';



// WEBPACK FOOTER //
// ./src/store/error/actions.type.js